import React, { useState } from "react";
import { X } from "lucide-react";

export default function OrderSupplementModal({ onClose, onSubmit, loading }) {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || !reason) return;
    
    onSubmit({
      amount: parseFloat(amount),
      reason: reason
    });
  };

  return (
    <div className="tripOverlay">
      <div className="tripCard" style={{ maxWidth: "450px" }}>
        <div className="tripHeader">
          <div className="blockTitle">Ajouter un supplément</div>
          <button onClick={onClose} className="btnIconDelete">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="usersGrid">
          <div className="vehicleItemModern" style={{ background: "#f3f4f6" }}>
            <label className="vehicleLabel">Motif du frais</label>
            <input
              type="text"
              className="modernInput"
              placeholder="Ex: Frais d'attente..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
              style={{ width: "100%", border: "none", background: "transparent", outline: "none", fontWeight: "600" }}
            />
          </div>

          <div className="vehicleItemModern" style={{ background: "#f3f4f6" }}>
            <label className="vehicleLabel">Montant (CFA)</label>
            <input
              type="number"
              className="modernInput"
              placeholder="0"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              style={{ width: "100%", border: "none", background: "transparent", outline: "none", fontWeight: "600" }}
            />
          </div>

          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button 
              type="button" 
              className="btnDanger" 
              onClick={onClose} 
              style={{ flex: 1, justifyContent: "center" }}>
              Annuler
            </button>

            <button 
              type="submit" 
              className="btnSuccess" 
              disabled={loading}
              style={{ flex: 2, justifyContent: "center" }}
            >
              {loading ? "Enregistrement..." : "Confirmer le supplément"}
            </button>
            
          </div>
        </form>
      </div>
    </div>
  );
}